module.exports = __webpack_public_path__ + "static/img/logo_txt.8c50331c.png";